import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./AnimatedSequence.css";

// Images
import img1 from "../Assets/LOGO/anim2.png";
import img2 from "../Assets/LOGO/anim3.png";
import img3 from "../Assets/LOGO/anim4.png";
import img4 from "../Assets/LOGO/anim5.png";

// Icons
import {
  FaCity,
  FaHeartbeat,
  FaLaptopCode,
  FaGem,
  FaUniversity,
  FaBuilding,
  FaUmbrellaBeach,
  FaLeaf,
  FaHandsHelping,
} from "react-icons/fa";

export default function AnimatedSequence() {
  const [stage, setStage] = useState(0);
  const [textIndex, setTextIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState(null); // 👈 new state for hover
  const navigate = useNavigate();

  const textList = [
    "Builders",
    "Healthcare",
    "Technologies",
    "Gold & Diamond",
    "Education",
    "Properties",
    "Resort",
    "Agrotech",
    "Trust",
  ];

  const iconList = [
    <FaCity />,
    <FaHeartbeat />,
    <FaLaptopCode />,
    <FaGem />,
    <FaUniversity />,
    <FaBuilding />,
    <FaUmbrellaBeach />,
    <FaLeaf />,
    <FaHandsHelping />,
  ];

  const linkList = [
    "/Builders",
    "/Healthcare",
    "/Technologies",
    "/Goldandiamonds",
    "/Educational",
    "/Properties",
    "/Hospitality",
    "/Agrotech",
    "/Foundation",
  ];

  // Step 1: Start Stage
  useEffect(() => {
    const timer = setTimeout(() => setStage(2), 1000);
    return () => clearTimeout(timer);
  }, []);

  // Step 2: Auto Rotate
  useEffect(() => {
    if (stage === 2) {
      const interval = setInterval(() => {
        setTextIndex((prev) => (prev + 1) % textList.length);
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [stage]);

  // 🎯 If hovering, hover overrides auto rotation
  const activeIndex = hoverIndex !== null ? hoverIndex : textIndex;

  return (
    <div className="animated-container">
      <div className="row-section">
        
        {/* Static Images */}
        {stage >= 1 && (
          <div className="horizontal-images">
            {[img1, img2, img3, img4].map((src, i) => (
              <img key={i} src={src} className="side-image" alt={`img${i}`} />
            ))}
          </div>
        )}

        {/* Rotating OR Hover Text */}
        {stage >= 2 && (
          <div className="text-section">
            <AnimatePresence mode="wait">
              <motion.h1
                key={textList[activeIndex]}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
                className="tech-text"
              >
                {textList[activeIndex]}
              </motion.h1>
            </AnimatePresence>
          </div>
        )}
      </div>

      {/* Icons */}
      {stage >= 2 && (
        <div className="bottom-icons">
          {iconList.map((icon, i) => (
            <div
              key={i}
              className={`bottom-icon ${i === activeIndex ? "active-icon" : ""}`}
              onClick={() => navigate(linkList[i])}
              onMouseEnter={() => setHoverIndex(i)}
              onMouseLeave={() => setHoverIndex(null)}
              title={textList[i]}
            >
              {icon}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
